import React from 'react';
import './Spinner.scss';

export default function Spinner(props) {
  return (
    <div id="loading" className={props.className}></div>
  )
}